export default __webpack_public_path__ + "static/media/success.767e648e.png";